export const EDUCATION = ["none", "primary", "secondary", "preparatory", "tvet", "diploma", "bachelor", "master", "phd", "other"];
export const BANKS = [
  "Commercial Bank of Ethiopia (CBE)", "Telebirr", "Awash Bank", "Dashen Bank", "Bank of Abyssinia", "Wegagen Bank", "Hibret Bank",
  "Nib International Bank", "Cooperative Bank of Oromia", "Oromia Bank", "Zemen Bank", "Bunna Bank", "Berhan Bank", "Abay Bank",
  "Enat Bank", "Development Bank of Ethiopia", "Other",
];
export const PACKAGES = ["silver", "gold", "gold_plus"];
